<template>
  <div id="content" v-if="!loading">
    <popup v-show="hasPopup"
           :popup-type="getPopupType"
           :popup-action="getPopupAction"
           @popup-action="executePopupAction"></popup>
    <form>
      <div class="inner">
        <p class="paging">
          <router-link :to="{ name: moduleName }" class="btn btn_back" v-translate>Seznam</router-link>
        </p>
        <h1 v-translate>Detail exportu</h1>
      </div>

      <div class="responsiveTabs">
        <div class="tabs_content">
          <section>
            <div class="left">
              <detail-entity-info :entity="entity">
                <p><translate>Počet spuštění</translate>: <span class="date" v-html="entity.run_count"></span></p>
                <p><translate>Poslední spuštění</translate>: <span class="date" v-html="$_date_formatFull(entity.last_run_date)"></span></p>
              </detail-entity-info>
            </div>
            <div class="right">
                <textarea-input
                    id="exportDescription"
                    :disabled="true"
                    v-model="entity.description"
                    ref="exportdescriptionref"
                ><translate class="translate">Popis exportu</translate>
                </textarea-input>
             <div :class="getFieldClass(index)"
                  v-for="(placeholder, key, index) in entity.placeholders"
             >
               <select-box
                   v-if="placeholder.type === 'bool'"
                   :id="placeholder.name"
                   :options="booleanOptions"
                   :required="true"
                   :disabled="!isEditable"
                   v-model="placeholdersData[placeholder.name]"
                   @input="updateParams($event, placeholder.name)"
               >
                 {{placeholder.description ? placeholder.description : placeholder.name}}
               </select-box>
               <date-picker
                   v-else-if="placeholder.type==='datetime'"
                   edit-time
                   :id="placeholder.name"
                   :disabled="!isEditable"
                   v-model="placeholdersData[placeholder.name]"
                   @update-date="updateParams($event.date, placeholder.name)"
               >
                 {{placeholder.description ? placeholder.description : placeholder.name}} *
               </date-picker>
               <text-input
                   v-else
                   :id="placeholder.name"
                   v-model="placeholdersData[placeholder.name]"
                   :required="true"
                   :disabled="!isEditable"
                   @change="updateParams($event, placeholder.name)"
                   :help-text="getHelpText(placeholder.type)"
               >
                 {{placeholder.description ? placeholder.description : placeholder.name}}
               </text-input>
             </div>
            </div>
          </section>
          <section class="buttons">
            <p>
              <input
                  v-if="isEditable"
                  type="submit"
                  :class="['btn']"
                  :value="$gettext('Spustit')"
                  @click.prevent.stop="runExport()" />
              <router-link
                  :to="{ name: moduleName }"
                  class="btn btn_back btn_seznam"
                  v-translate>Seznam
              </router-link>
            </p>
          </section>
        </div>
      </div>
    </form>
  </div>
</template>


<script>
import detailActions from "@/components/mixins/detail-actions"
import {downloadTableFile} from "@/utils/helpers"

	export default {
		name: "CustomExportDetail",
    mixins: [detailActions],
		data() {
			return {
        placeholdersCount: 0,
				loading: true,
        hideForm: true,
        entityName: 'customExport',
        moduleName: 'customExports',
        placeholdersData: {},
        params: {},
			}
		},
		created(CustomExportService) {
			this.entityService = CustomExportService
			this.createdInit()
          .then(()=>{
        for(let key in this.entity.placeholders)
        {
          this.params[this.entity.placeholders[key].name] = null;
        }
      });
		},
    computed: {
      isEditable(){
        return this.$_readActionAllowed;
      },
      booleanOptions(){
        return [
          {
            value: true,
            text: this.$gettext('Ano')
          }, {
            value: false,
            text: this.$gettext('Ne')
          }];
      }
    },
    methods:{
      runExport(){
        for(let key in this.params){
          if(!this.params[key]){
            this.setErrorMessage(this.$gettext('Všechny parametry musí být vyplněny'));
            return;
          }
        }

        this.setLoadingMessage();
        this.entityService.runExport(this.entity.id, {params: this.params}).then((response) => {
          this.setInfoMessageWithTimeout(this.$gettext('Stahování souboru...'))
          downloadTableFile(response, 'backoffice-export');
        }).catch(error => {
          console.error(error);
          this.setErrorMessage(error.error_message);
        })
      },
      getFieldClass(index){
        return index % 2 ? 'field_right': 'field_left';
      },
      updateParams(data, name){
        this.params[name] = data
      },
      getHelpText(type){
        if(type === 'array'){
          return this.$gettext('Více hodnot oddělených středníkem');
        }else{
          return '';
        }
      }
    },
	}
</script>



// WEBPACK FOOTER //
// src/components/views/customExports/CustomExportDetail.vue